import React from 'react';

const VehicleInfoModal = ({ 
    currentVin, 
    currentMileage, 
    currentVehicleDescription, 
    newVehicleYear, 
    newVehicleMake,
    newVehicleModel,
    modifiedVehicle,
    handleChange 
}) => {
    return (
        <div className="modal fade" id="vehicle_modal" tabIndex={-1} role="dialog" aria-labelledby="vehicle_modal" aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                <div className="modal-content">
                    <div className="modal-body">
                        <div className="row">
                            <div className="col-xl-6">
                                {/* Account details card */}
                                <div className="card mb-4">
                                    <div className="card-header">Current Vehicle</div>
                                    <div className="card-body">
                                        <form>
                                            <input type="hidden" value="autocompleteworkaround" />
                                            <div className="row gx-3 mb-3">
                                                <div className="col-md-12">
                                                    <label className="large mb-1 vehicle_label" htmlFor="inputVin">VIN</label>
                                                    <p>{currentVin}</p>
                                                </div>
                                                <div className="col-md-12">
                                                    <label className="large mb-1 vehicle_label" htmlFor="inputMileage">Mileage</label>
                                                    <p>{currentMileage}</p>
                                                </div>
                                                <div className="col-md-12">
                                                    <label className="large  mb-1 vehicle_label" htmlFor="inputCollateral">Vehicle</label>
                                                    <p>{currentVehicleDescription}</p>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="card mb-4">
                                    <div className="card-header">New Vehicle</div>
                                    <div className="card-body">
                                        <form>
                                            <input type="hidden" value="autocompleteworkaround" />
                                            <div className="row gx-3 mb-3">
                                                <div className="col-md-12">
                                                    <label className="small mb-1" htmlFor="rec_vin">VIN</label>
                                                    <input id="rec_vin" name="rec_vin" type="text" className="form-control app_input input_height" maxLength={17} onChange={handleChange} />
                                                </div>
                                                <div className="col-md-12">
                                                    <label className="small mb-1" htmlFor="rec_veh_mileage">Mileage</label>
                                                    <input id="rec_veh_mileage" name="rec_veh_mileage" type="number" min="0" className="form-control app_input input_height" maxLength={6} onChange={handleChange} />
                                                </div>
                                                <div className="col-md-12">
                                                    <label className="small mb-1" htmlFor="dotYear">Year</label>
                                                    <input className="form-control app_input input_height" id="dotYear" type="text" value={newVehicleYear ? newVehicleYear : ""} readOnly />
                                                </div>
                                                <div className="col-md-12">
                                                    <label className="small mb-1" htmlFor="dotMake">Make</label>
                                                    <input className="form-control app_input input_height" id="dotMake" type="text" value={newVehicleMake ? newVehicleMake : ""} readOnly />
                                                </div>
                                                <div className="col-md-12">
                                                    <label className="small mb-1" htmlFor="dotModel">Model</label>
                                                    <input className="form-control app_input input_height" id="dotModel" type="text" value={newVehicleModel ? newVehicleModel : ""} readOnly />
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        {modifiedVehicle ?
                            <div style={{ color: 'blue', marginRight: '20px' }}>
                                You have changed the vehicle. Please make sure to adjust the<br />Sale Price and click the Rehash button after you exit this dialog box.
                            </div> :
                            ''}
                        <button className="btn btn-success" type="button" data-bs-dismiss="modal">Save</button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default React.memo(VehicleInfoModal);
